var _path, _path2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcaIconLightidle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.001,0c-27.616,0-50,22.388-50,50c0,0.28,0.015,0.554,0.021,0.829L22.42,37.705l26.32,15.204v31.064 L29.154,95.446C35.5,98.362,42.559,100,50.001,100C77.611,100,100,77.615,100,50C100,22.388,77.611,0,50.001,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_LIGHTIDLE",
    gradientUnits: "userSpaceOnUse",
    x1: 10.5469,
    y1: 81.2363,
    x2: 43.8121,
    y2: 47.9711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#485CC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_LIGHTIDLE)",
    d: "M22.42,37.705L0.021,50.829c0.324,19.815,12.168,36.818,29.133,44.617L48.74,83.974V52.9 L22.42,37.705z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#485CC7",
    points: "22.42,37.705 48.74,52.909 48.74,83.974 93.52,25.338 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcaIconLightidle);
export default __webpack_public_path__ + "static/media/proca-icon-lightidle.f574e0c7.svg";
export { ForwardRef as ReactComponent };